import{k as t,d as i,_ as r}from"./utilities-ba968232.js";var s=function(s){return"string"==typeof s||!t(s)&&i(s)&&"[object String]"==r(s)};export{s as i};
